<template>
  <div id="#app">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" :key="$route.name" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <component :is="Component" :key="$route.name" v-if="!$route.meta.keepAlive" />
    </router-view>
    <!-- <router-view /> -->
  </div>
</template>

<script>
import { onMounted } from "vue";
import { useStore } from "vuex";
export default {
  setup() {
    const store = useStore().state;
    const setFavicon = () => {
      let noIcon = ["chilad", "yuantong"].some(
        (item) => item === window.XINPOC_WEB_CONFIG.isProject
      );
      if (noIcon) {
        return;
      }
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      let iconUrl = `${window.XINPOC_WEB_CONFIG.isProject}.ico`;
      link.href = iconUrl;
    };

    onMounted(() => {
      store.XINPOC_WEB_CONFIG = window.XINPOC_WEB_CONFIG;
      // window.XINPOC_WEB_CONFIG.isProject
      setFavicon();
    });

    return { setFavicon };
  },
};
</script>

<style lang="less">
:root {
  --main-bg-color: #2776c3;
  /*芯对讲*/
  --main-andfn-color: #2776c3;
  /*芯对讲*/
  --main-cor-color: #2776c3;
  /*芯对讲*/
}

#app {
  padding: 0px;
  margin: 0px;
  font-size: 15px;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

// 弹性盒子
.flex_box {
  display: flex;
}

.flex-algin {
  display: flex;
  align-items: center;
}

.flex-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex_end {
  //右边对齐
  display: flex;
  align-items: center;
  justify-content: end;
}

.flex_zy {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex_item {
  flex: 1;
}

.flex_wrap {
  flex-wrap: wrap;
}

.flex_one {
  flex: none !important;
  -webkit-box-flex: none !important;
  -webkit-flex: none !important;
}

.relative {
  position: relative;
}

.bro {
  border-radius: 5px;
  overflow: hidden;
}

.ios {
  padding-bottom: constant(safe-area-inset-bottom);
  /*兼容 IOS<11.2*/
  padding-bottom: env(safe-area-inset-bottom);
  /*兼容 IOS>11.2*/
}

.margin_top {
  margin-top: 10px;
}

.margins-right {
  margin-right: 10px;
}

.border-top {
  border-top: 1px solid #c8c7cc;
}

.border-bot {
  border-bottom: 1px solid #c8c7cc;
}

.huise {
  color: #999999;
}

.extend {
  font-size: 14px;
  color: #bbb;
}

.home_bg {
  width: 100%;
  height: 100vh;
  overflow: auto;
  background-color: #ededed;
  // font-size: 15px;
}

.field_bg {
  background-color: #ffffff;
}

.field_tips {
  padding: var(--van-cell-vertical-padding) var(--van-cell-horizontal-padding);
}

// .home_bg_tow{
//   width: 100%;
//   height: calc(100vh - 10px);
//   overflow: auto;
//   background-color: #ededed;
// }

.toomit {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}

// 按钮定位
.footer-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 11;
  background: #fff;
  padding-bottom: constant(safe-area-inset-bottom);
  /*兼容 IOS<11.2*/
  padding-bottom: env(safe-area-inset-bottom);
  /*兼容 IOS>11.2*/
}

.theme_btn {
  height: 44px;
  line-height: 44px;
  padding: 0;
  text-align: center;
  background-color: #ffffff;
  color: #fff;
  font-size: 15px;
}

.theme_btn:active {
  opacity: 0.7;
}

.theme_box {
  height: 44px;
}

.theme_bg {
  background-color: var(--main-bg-color) !important;
}

.bottom {
  width: 100%;
  height: 50px;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: env(safe-area-inset-bottom);
  color: var(--main-bg-color);
  // height: var(--van-nav-bar-height);
}

.btn_color:active {
  opacity: 0.7;
}

// 单元格样式

.label_color {
  color: #a8a8a8;
}

.value_color {
  color: #000000 !important;
}

.title_sz {
  //字体大小
  font-size: 16px !important;
}

.value_sz {
  //字体大小
  font-size: 14px !important;
}

.label_width {
  width: 100px;
}

.hei {
  margin: 10px 0px;
}

.padding_right {
  padding-right: 5px !important;
}

.input_box {
  border: 1px solid #ccc;
  border-radius: 3px;
}

// 搜索定位
.box_fixed {
  position: fixed;
  top: 46px;
  left: 0px;
  right: 0px;
  z-index: 1;
  padding: 10px 15px;
  background-color: #efeff4;
}

// 颜色值

.color_blue {
  color: #1c94dc;
}

.color_orange {
  color: #edae4c;
}

.theme_color {
  color: var(--main-bg-color);
}

.color_red {
  color: #f00;
}

.bule {
  color: #000000 !important;
}

.bg_white {
  background-color: #ffffff;
}

.theme_border {
  border-top: 1px solid var(--main-bg-color);
}

.widhe {
  //宽高百分比
  width: 100%;
  height: 100%;
}

// 更改field样式
.field_label {
  padding: 12px;
}

.field_Input {
  line-height: 20px !important;
  padding: 12px 10px !important;
}

input.van-field__control::-webkit-input-placeholder {
  color: #656565;
  // color: #bebebe;
}

.input_width {
  width: 100%;
  border: none;
  padding: 0px;
}

.nodata {
  width: 100%;
  height: 100px;
  line-height: 100px;
  text-align: center;
  color: #999999;
}

// vant 样式修改

.van-picker__confirm {
  color: var(--main-bg-color) !important;
}

.van-switch--on {
  background: var(--main-bg-color) !important;
}

.van-radio__icon--checked .van-icon {
  background-color: var(--main-bg-color) !important;
  border-color: var(--main-bg-color) !important;
}

// css换行
.breakspaces {
  white-space: break-spaces;
}
</style>
